// The name and MIME type a video should carry when it leaves the app through
// the share sheet.
//
// Chrome's Web Share implementation matches a shared file's type against its
// allowlist with an exact string comparison, so a parameterised type
// ("video/mp4;codecs=avc1") never matches "video/mp4": canShare() refuses the
// file and the share degrades to sending a URL, which a target like Instagram
// then treats as a text post. Safari applies no such allowlist, which is why
// only Android ever showed it.
//
// This mirrors webapp/src/utils/shareFile.js. The two apps are separate repos,
// so the rule is copied rather than imported — keep them in step.

// The extensions a reel's title may still be carrying from the file it was
// uploaded as.
const VIDEO_EXTENSION = /\.(?:mp4|mov|m4v|webm|mkv|avi|mpg|mpeg|ogv|3gp)$/i

export function buildShareFile(blob, title) {
    const type = (blob.type || '').split(';')[0].trim().toLowerCase() || 'video/mp4'
    const ext = type.includes('webm') ? 'webm' : 'mp4'
    // Share targets receive the name as-is; keep it to characters that survive
    // a filesystem and an Android intent. Reels uploaded before titles were
    // separated from file names still carry the extension in the title, and
    // without dropping it it survives as "-mp4" in the middle of the name.
    // Only a video extension comes off: a title is human text, so a "2026.02"
    // is part of the name, not a file type.
    const slug = String(title || '')
        .replace(VIDEO_EXTENSION, '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'video'
    return new File([blob], `crowds-${slug}.${ext}`, { type })
}
